import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type State = {
  userToken: string | undefined | null;
  lineUserId: string | undefined | null;
  sessionExpired: boolean;
};

const initialState: State = {
  userToken: undefined,
  lineUserId: undefined,
  sessionExpired: false,
};

// Liffログイン時にユーザー識別用のトークンを保持する
export const liffUser = createSlice({
  name: 'liffUser',
  initialState,
  reducers: {
    successLiffLogin: (state, action: PayloadAction<{ userToken: string; lineUserId: string }>) => {
      state.userToken = action.payload.userToken;
      state.lineUserId = action.payload.lineUserId;
      state.sessionExpired = false;
    },
    failureLiffLogin: state => {
      state.userToken = null;
      state.lineUserId = null;
      state.sessionExpired = false;
    },
    setSessionExpired: state => {
      state.sessionExpired = true;
    },
    clearSessionExpired: state => {
      state.sessionExpired = false;
    },
  },
});
export const { successLiffLogin, failureLiffLogin, setSessionExpired, clearSessionExpired } =
  liffUser.actions;

export default liffUser.reducer;
